import ZkMenu from './src/menu';

/* istanbul ignore next */
ZkMenu.install = function(Vue) {
  Vue.component(ZkMenu.name, ZkMenu);
};

export default ZkMenu;



// WEBPACK FOOTER //
// ./src/packages/menu/index.js